import emblaCarousel from 'embla-carousel';
import { setupTweenOpacity, addPrevNextBtnHandlers } from './carousel-util';

export const init = () => {
  const tSliders = document.querySelectorAll('[data-carousel]');

  tSliders.forEach((slider) => {
    const viewport = slider.querySelector('[data-carousel-viewport]');
    if (!viewport) return;

    const embla = emblaCarousel(viewport, {
      skipSnaps: true,
      containScroll: 'keepSnaps',
      loop: true,
      align: 'start'
    });

    const slides = slider.querySelectorAll('[data-carousel-slide]');

    slides[0].setAttribute('aria-hidden', false);

    const { applyTweenOpacity, removeTweenOpacity } = setupTweenOpacity(
      embla,
      0.1
    );

    embla.on('select', () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      slides[previous].setAttribute('aria-hidden', true);
      slides[selected].setAttribute('aria-hidden', false);
      const prevLink = slides[previous].querySelector('.js-carousel-link');
      if (prevLink) prevLink.setAttribute('tabindex', -1);
      const selectedButton =
        slides[selected].querySelector('.js-carousel-link');
      if (selectedButton) selectedButton.removeAttribute('tabindex');
    });

    const nextBtn = slider.querySelector('[data-carousel-next]');
    const prevBtn = slider.querySelector('[data-carousel-prev]');

    const removePrevNextBtnsClickHandlers = addPrevNextBtnHandlers(
      embla,
      prevBtn,
      nextBtn
    );

    embla
      .on('init', applyTweenOpacity)
      .on('scroll', applyTweenOpacity)
      .on('reInit', applyTweenOpacity)
      .on('destroy', removeTweenOpacity)
      .on('destroy', removePrevNextBtnsClickHandlers);
  });
};
